import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-login-failed',
    imports: [],
    templateUrl: './login-failed.html'
})
export class LoginFailed { }

